import { CompareFieldGroupWrapper } from '@modules/quantify/components/CompareFieldGroupWrapper';
import { CompareHighlightWrapper } from '@modules/quantify/components/CompareHighlightWrapper';
import { CompareFieldGroupHeader } from '@modules/quantify/components/QuantifyQueryBuilder/Fields/CompareFieldGroupHeader';
import { CompareDurationA } from '@modules/quantify/components/QuantifyQueryBuilder/Fields/DurationField/CompareDurationA';
import { CompareDurationB } from '@modules/quantify/components/QuantifyQueryBuilder/Fields/DurationField/CompareDurationB';
import { Box, Stack } from '@mui/material';

interface CompareByTimeFieldGroupProps {
  onRemove: () => void;
}

export const CompareByTimeFieldGroup = ({
  onRemove,
}: CompareByTimeFieldGroupProps) => {
  return (
    <CompareHighlightWrapper isActive shouldShowOutline>
      <Stack
        px={2}
        py={1.5}
        spacing={1.5}
        data-testid="quantify-compare-by-time-field-group"
      >
        <CompareFieldGroupHeader
          title="Compare by Time"
          subtitle="Duration"
          onRemove={onRemove}
        />
        <Box pl={0.5}>
          <CompareFieldGroupWrapper
            fieldA={<CompareDurationA />}
            fieldB={<CompareDurationB />}
            relationIndicatorSx={{ mt: 0.6 }}
          />
        </Box>
      </Stack>
    </CompareHighlightWrapper>
  );
};
